<template>
  <div class="leaveWord">
    <div class="page-width-warpper">
      <Title title="在线留言" en="MESSAGE" align="left" />
      <div class="form-warpper">
        <el-form :inline="!isMobile" :model="formInline" ref="formDom">
          <el-form-item>
            <el-input
              v-model="formInline.name"
              placeholder="您的称呼"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.mobile"
              placeholder="联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.email"
              placeholder="电子邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.company"
              placeholder="公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.address"
              placeholder="所在位置"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.content"
              placeholder="留言主题"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-select v-model="formInline.region" placeholder="活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          v-model="formInline.content"
          placeholder="留言内容"
        ></el-input>
      </div>
      <div class="submit">
        <my-button @click="onSubmit">提交信息</my-button>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  components: {
    Title,
    MyButton,
  },
  data() {
    return {
      formInline: {},
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    onSubmit() {
      console.log(11);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css

.leaveWord {
  padding: 60px 0;
  background: #f9f9f9;
  ::v-deep .form-warpper {
    padding: 40px 0;
    .el-form--inline {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: calc(33.3% - 17px);
        margin-right: 26px;
        margin-bottom: 30px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .el-form-item__content,
        .el-select {
          display: block;
          // background: #fff;
        }
      }
    }
    .el-input__inner,
    .el-textarea__inner {
      border-color: #efefef;
    }
  }
  .submit {
    display: flex;
    justify-content: center;
  }
}
.isMobile {
  .leaveWord {
    padding: 30px 0;
    .form-warpper {
      padding: 20px 0;
    }
    .el-form-item {
      margin-bottom: 13px;
    }
  }
}
</style>
